import React from 'react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/66ByGuoXAd2E2dnDTzSq3B/I9_Logo_Hi_Res_Multicolor.png';
export function I9Logo({
  className = 'h-11 w-auto lg:h-[84px]'
}: {
  className?: string;
}) {
  return <img src={LOGO_URL} alt="i9 Sports" className={className} data-id="element-101" data-mp="172dqwlygc5n5" />;
}